import { useRef } from 'react';

import useWxNavbar from '@/hooks/use-wx-navbar';
import { NavItem } from '@/types/whoami';

export type WxNavbarHostProps = {
  userId?: string;
  locale?: string;
  companyId?: string;
  inboxCount?: number;
  employerDomain?: string;
  employerBasePath?: string;
  disableNavigation?: boolean;
  mainConfig?: NavItem[];
  secondaryConfig?: NavItem[];
  dropdownConfig?: NavItem[];
};

export default function WxNavbarHost(props: WxNavbarHostProps) {
  const ref = useRef<HTMLDivElement>(null);

  // forward all props 1:1 to the UMD render via the hook
  useWxNavbar({ mountRef: ref, renderProps: props });

  return <div id="wx-navbar-root" ref={ref} />;
}
